import { getEnhancedPlans } from '../api/spm';
export default async (logger) => getEnhancedPlans({}, logger);
